export enum PlaceVariant {
  AVAILABLE = "available",
  OCCUPIED = "occupied",
  WEAK = "weak",
  FORBIDDEN = "forbidden",
  TEMP = "temp"
}
